import { HTMLAttributes } from 'react';

import { clsx } from 'clsx';

import { MarxLogo } from './marx-logo';

interface FullScreenLoaderProps extends HTMLAttributes<HTMLDivElement> {
  visible?: boolean;
}

/**
 * Full-screen loading overlay
 * Used to block UI until critical data (e.g., tenant config) is loaded.
 * Features a breathing color animation between PharmHub red and MedHub beige (#BC9672).
 */
export function FullScreenLoader({
  visible = true,
  className,
  ...props
}: FullScreenLoaderProps) {
  return (
    <div
      role="status"
      aria-busy={visible}
      aria-label="Loading"
      className={clsx(
        'fixed inset-0 z-[9999] flex items-center justify-center bg-white-10 transition-opacity delay-200 duration-[400ms]',
        visible ? 'opacity-100' : 'pointer-events-none opacity-0',
        className
      )}
      {...props}
    >
      <MarxLogo
        aria-hidden="true"
        className="w-48 animate-logo-breathe md:w-64"
      />
    </div>
  );
}
